export enum PORTALTYPE {
    ADMIN = 'admin',
    VENUE = 'venue_owner',
};